import React, { useState } from 'react';
import '../css/common.css';
import ScrollTopButton from '../components/ScrollTopButton';
import Tabs from '../components/Tabs';
import bgptl from '../assets/images/bgptl.jpg';
import icoMainselOld from '../assets/images/ico_mainsel_old.png';
import icoMainselOxy from '../assets/images/ico_mainsel_oxy.png';
import icoMainselChair from '../assets/images/ico_mainsel_chair.png';
import icoMainselPaper from '../assets/images/ico_mainsel_paper.png';
import seblog01 from '../assets/images/seblog01.png';
import seblog02 from '../assets/images/seblog02.png';

import { Link } from 'react-router-dom';

function Main() {

 
 const [modalOpen, setModalOpen] = useState(false);
    
 const warpPotalStyle = {
    backgroundImage: `url(${bgptl})`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
  };

  
  const openModal = (e) => {
    e.preventDefault();
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
  };

  return (
    <div className="warp potal" style={warpPotalStyle}>
        <div className="contbox">
              <div className="inner">
                  <div className="texmainbx">
                          <div className="subt">
                            <p>장기요양보험</p>
                          </div>
                          <div className="txtnbx">
                            <p className="title">다드림복지용구</p>
                            <a href="tel:1533-5921">
                              <span className="description">문의처 : 1533-5921</span>
                            </a>
                            <i>(다드림 지원 콜센터)</i>
                          </div>

                          <div className="sublogbx">
                            <img src={seblog01}/>
                            <img src={seblog02}/>
                          </div>
                  </div>
              </div>

      <div className="inner">
        <div className="selmenu-container">

              <a href="https://bc1592.gagaon.com/" target="_blank" rel="noopener noreferrer">
                <div className="selmenu-card menu-blue">
                  <div className="icon"><img src={icoMainselOld} /></div>
                  <div className="title">복지용구</div>
                  <div className="desc">장기요양등급을 받으신 어르신</div>
                </div>
              </a>

              <Link to="/Oxy">
                <div className="selmenu-card menu-orange">
                  <div className="icon"><img src={icoMainselOxy} /></div>
                  <div className="title">산소발생기</div>
                  <div className="desc">산소치료 처방전을 받으신 분</div>
                </div>
              </Link>

              <Link to="/Teun">
                <div className="selmenu-card menu-green">
                  <div className="icon"><img src={icoMainselChair} /></div>
                  <div className="title">휠체어대여</div>
                  <div className="desc">재활환자, 거동이 불편하신분</div>
                </div>
              </Link>

              <div onClick={openModal} style={{ cursor: 'pointer' }}>
                <div className="selmenu-card menu-pink">
                  <div className="icon"><img src={icoMainselPaper} /></div>
                  <div className="title">자격증 취득</div>
                  <div className="desc">생활지원사, 병원동행매니저</div>
                </div>
              </div>
        </div>
      </div>

        <div className="inner">
            <div className="qnabx">
                    <Tabs/>
            </div>
        </div>

  </div>
        <ScrollTopButton />

{/* 모달 */}
{modalOpen && (
  <div className="modal-overlay" onClick={closeModal}>
    <div className="modal-content" onClick={(e) => e.stopPropagation()}>
      {/* 모달 헤더 */}
      <div className="modal-header">
        <h2 className="modal-title" style={{ margin: 0 }}>자격증 취득</h2>
        <button
          className='modal-close'
          onClick={closeModal}
          style={{
            fontSize: '24px',
            background: 'transparent',
            border: 'none',
            color: '#fff',
            cursor: 'pointer',
          }}
          aria-label="Close Modal"
        >
          &times;
        </button>
      </div>

      {/* 모달 본문 */}
      <div className="modal-body" style={{ padding: '20px', textAlign: 'center' }}>
        <div className="modal-btitle" style={{ marginBottom: '20px' }}>
          자격증 취득에<br /> 관심 가져주셔서 감사합니다.
        </div>
        <div className="modal-btitle2">
          자격증 취득에 관련된 문의사항은 아래의 연락처로 문의해주시고 <br/>
          자세한 사항은 해당 사이트에서 확인 가능합니다.
        </div>

        {/* 버튼 스타일 */}
        <div style={{ display: 'flex', justifyContent: 'center', gap: '20px' }}>
          <a href="tel:1533-5921" style={{ textDecoration: 'none' }}>
            <button>
              전화상담
            </button>
          </a>

          <a href="https://www.jobpyeong.com/" target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none' }}>
            <button>
              사이트 방문
            </button>
          </a>
        </div>
      </div>
    </div>
  </div>
)}

    </div>

  );
}

export default Main;
